import { render, staticRenderFns } from "./FichaActaEscrutinio.vue?vue&type=template&id=a27dc8e2"
import script from "./FichaActaEscrutinio.vue?vue&type=script&lang=js"
export * from "./FichaActaEscrutinio.vue?vue&type=script&lang=js"
import style0 from "./FichaActaEscrutinio.vue?vue&type=style&index=0&id=a27dc8e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports